import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

const root = document.getElementById('root');
root.replaceChildren();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  root
);
